module.exports = __webpack_public_path__ + "static/media/bg_middle_tab2.baecd7ab.png";